import jsbridge from '@xpeng/js-bridge'
import ResponseType from './models/ResponseTypes'
import MessageBox from '../components/message-box'
// import * as Sentry from '@sentry/browser'
import { getPlatform } from '../utils/common'
// import jsCookie from 'js-cookie'

const NETWORK_SUCCESS_CODE = [0, 200]
const NETWORK_TIMEOUT_SECOND = 10
const baseUrl = ''
const mockBaseUrl = 'http://mock.test.xiaopeng.local/mock/326'

class NetworkTimeoutMsg { }
const networkTimeoutMsg = new NetworkTimeoutMsg()
function getNetworkTimeoutPromise(): Promise<NetworkTimeoutMsg> {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(networkTimeoutMsg)
    }, NETWORK_TIMEOUT_SECOND * 1000)
  })
}

function getNetworkRequestPromise<T, P>(
  url: string,
  params?: T,
  method: string = 'GET',
  extension: string = ''
): Promise<ResponseType<P> | void> {
  const loginCheck = jsbridge
    .callHandler('getLoginState', {})
    .then((res) => {
      if (res.data && typeof res.data === 'string') {
        res.data = JSON.parse(res.data)
      }

      let preUid = '0'
      if (Number(res.loginState) === 1 && res.data.uid) {
        preUid = res.data.uid

        // 缓存用户类型 //1=车主，2=普通用户,3=租客
        // jsCookie.set('xpeng_user_type', res.data.carownerflag || 2)
      } else {
        // 不检验登陆
        if (extension === '1') {
          throw new Error('login error')
        }
      }
      return preUid
    })
    .catch(() => {
      // 不检验登陆
      if (extension === '1') {
        throw new Error('login error')
      }
    })
  return loginCheck
    .then(() => {
      let urlPath: string = url
      const platform = getPlatform()
      if (method === 'GET' && params && (platform === 'android' || platform === 'harmony')) {
        const keys = Object.keys(params)
        keys.length &&
          (urlPath +=
            '?' +
            keys
              .map((key): string => {
                return `${key}=${params[key]}`
              })
              .join('&'))
      }
      const realUrl = `${baseUrl}${urlPath}`

      console.log('准备请求', realUrl, params, method)

      return jsbridge
        .callHandler('request', {
          url: realUrl,
          options: {
            method,
            body: params,
          },
        })
        .then((res: ResponseType<P>) => {
          return res
        })
    })
    .catch((err: Error) => {
      if (err.message && err.message === 'login error') {
        MessageBox.alert('登录已失效，请重新登录', {
          showCancelButton: false,
        }).then(() => {
          jsbridge
            .callHandler('goToNativePage', {
              pageType: 'login',
              data: {
                direct: window.location.href,
              },
            })
            .then(() => { })
          jsbridge.callHandler('closeWindow', {})
        })
      } else {
        throw err
      }
    })
}

type FetchFuc<T, P> = (url: string, params?: T, method?: string, extension?: string) => Promise<ResponseType<P>>
// extension 扩展参数 默认为“” “1”=不需要检验登录
export default function request<T, P>(
  url: string,
  params?: T,
  method?: string,
  extension?: string
): Promise<P extends ResponseType<infer A> ? A : never> {
  let fetchFunc: FetchFuc<T, P | void>

  if (
    process.env.NODE_ENV === 'development' &&
    process.env.REACT_APP_DATA_SOURCE === 'mock'
  ) {
    fetchFunc = (url: string): Promise<ResponseType<P | void>> => {
      return fetch(mockBaseUrl + baseUrl + url, { method: method || 'GET' })
        .then((res) => {
          if (res.status === 200) {
            return res.json()
          } else {
            throw new Error(res.statusText)
          }
        })
        .then((res: ResponseType<P>) => {
          return res
        })
    }
  } else {
    //@ts-ignore
    fetchFunc = getNetworkRequestPromise
  }

  return Promise.race([fetchFunc(url, params, method), getNetworkTimeoutPromise()])
    .then((value: any) => {
      console.log("value")
      console.log(value)
      if (value instanceof NetworkTimeoutMsg) {
        throw new Error('网络超时')
      } else {
        if (NETWORK_SUCCESS_CODE.includes(value.code)) {
          consoleRequest(url, params, value)
          return value.data
        }
        // 429 限流 503 熔断 直接返回code，展示异常页面
        throw new Error(
          value.code === 429 || value.code === 503 ? value.code :
            value.msg
              ? `服务器错误信息：${value.msg}`
              : `服务器返回错误码：${value.code}`
        )
      }
    })
    .catch((error) => {
      consoleRequest(url, params, null, error)
      throw error
    })
}

function consoleRequest(
  url: string,
  params: any,
  response: any,
  error: any = undefined
) {
  console.log(`================ request start ============`)
  console.log(`url: ${url}`)
  console.log('params： ')
  console.log(params)
  if (response) {
    console.log('response: ')
    console.log(response)
  }
  if (error) {
    console.log('error: ')
    console.log(error)
  }
  // Sentry.addBreadcrumb({
  //   type: 'network-request',
  //   message: `${url}`,
  //   data: {
  //     url,
  //     params,
  //     response: response || {},
  //     error: error || {},
  //   },
  // })
  console.log(`================ request end ============`)
}
